import { Info } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/ui/base/button';
import { ResponsiveModal } from '@/ui/ResponsiveModal';

import { SECOES_DA_INTEGRACAO } from './rotulos';

/**
 * Botão que abre a explicação da integração com a fonte oficial. Fica nas
 * telas de marcas, modelos e versões, na fila de grafias, na sincronização e
 * no cadastro e na edição de veículo.
 */
export function ComoFuncionaAIntegracao({ className }: { className?: string }) {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={className}
        onClick={() => setAberto(true)}
      >
        <Info className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
        Como funciona a integração
      </Button>
      <ResponsiveModal
        open={aberto}
        onOpenChange={setAberto}
        title="Como funciona a integração com a fonte oficial"
        description="Marcas, modelos e versões de veículo do TEG são conferidos todo dia com os dados públicos do governo."
        desktopMaxWidth="max-w-2xl"
        footer={
          <div className="flex w-full justify-end">
            <Button type="button" onClick={() => setAberto(false)}>
              Entendi
            </Button>
          </div>
        }
      >
        <div className="space-y-4">
          {SECOES_DA_INTEGRACAO.map((secao) => (
            <section key={secao.titulo} className="space-y-1">
              <h3 className="text-sm font-semibold">{secao.titulo}</h3>
              <p className="text-sm text-muted-foreground">{secao.texto}</p>
            </section>
          ))}
        </div>
      </ResponsiveModal>
    </>
  );
}
